/**
 * A singleton holding the idScenario the user is currently viewing. Used by
 * the axios request interceptor to attach `X-Scenario-Id` on every request,
 * so point-mutation endpoints (lock-shift, edit-work-time, etc.) can resolve
 * the flight scenario without each call site threading the id through.
 *
 * Updated by the gantt-chart-data action when a plan is fetched.
 */
export class ScenarioService {
  private static instance: ScenarioService;
  private idScenario: number | null = null;

  private constructor() {}

  public static getInstance(): ScenarioService {
    if (!ScenarioService.instance) {
      ScenarioService.instance = new ScenarioService();
    }
    return ScenarioService.instance;
  }

  public setIdScenario(id: number | null): void {
    this.idScenario = id;
  }

  public getIdScenario(): number | null {
    return this.idScenario;
  }
}
